import React, { forwardRef, ReactNode, Ref, useRef } from "react"
import { Drawer as AntDrawer, DrawerProps as AntDrawerProps, ConfigProvider } from 'antd'
import useTriggerOpen, { OpenRef, TriggerProps } from '../hooks/useTriggerOpen'
import { registerComponentProperty } from '../util/util'

export type DrawerRef = OpenRef

export interface DrawerProps extends Omit<AntDrawerProps, 'onClose' | 'onCancel' | 'onOk'>, TriggerProps {
  subtitle?: ReactNode
}

const Drawer = ({ children, className, title, subtitle, ...props }: DrawerProps, ref: Ref<DrawerRef>) => {
  const { el, onClose, ...triggerProps } = useTriggerOpen(ref, props)
  const DomRef = useRef<HTMLDivElement>(null)
  const getPopupContainer = () => {
    return DomRef?.current ?? document.body
  }

  return (
    <>
      {el}
      <AntDrawer
        {...props}
        {...triggerProps}
        title={
          subtitle ? (
            <div>
              <div>{title}</div>
              <div className="text-sm font-normal">{subtitle}</div>
            </div>
          ) : (
            title
          )
        }
        onClose={onClose}
      >
        <div ref={DomRef}>
          <ConfigProvider getPopupContainer={getPopupContainer}>{children}</ConfigProvider>
        </div>
      </AntDrawer>
    </>
  )
}

const forwardDrawer = forwardRef(Drawer)

export default registerComponentProperty<typeof forwardDrawer, typeof AntDrawer>(forwardDrawer, AntDrawer)
